import { createContext } from 'react';
import { TrafficAnalyticsPageData } from '../model/trafficanalytics';

const idleConst: "idle" | "success" | "failed" | "error" = "idle";
const defaultTrafficAnalyticsData = {
    status: idleConst,
    data: undefined, 
    error: null, 
    isFetching: false,
    timeRange: 7
}

export const TrafficAnalyticsContext = createContext<TrafficAnalyticsPageData>( defaultTrafficAnalyticsData  );